import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as categoriesApi from "@/api/categories.api";
import type { Category } from "@/types";

interface CategoriesState {
  items: Category[];
  loading: boolean;
}

const initialState: CategoriesState = {
  items: [],
  loading: false,
};

export const fetchCategories = createAsyncThunk(
  "categories/fetchAll",
  async () => {
    return await categoriesApi.getCategories();
  },
);

const categoriesSlice = createSlice({
  name: "categories",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategories.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.items = action.payload;
        state.loading = false;
      })
      .addCase(fetchCategories.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default categoriesSlice.reducer;
